import { appBaseUrl } from "@utils/BASE-URL";
import { LANGUAGE } from "@utils/constants";
import { readingTime } from "@utils/metrics/timeFunction";
import html2plaintext from "html2plaintext";

const getPureText = (htmlText) => {
  const text = html2plaintext(htmlText);

  let plainText = text.replace(/\n|\r/g, "");
  plainText =
    plainText.length > 110 ? plainText.slice(0, 110) + "..." : plainText;

  return plainText;
};

export const getBlogMetaData = (blogData) => {
  const headline =
    blogData?.mainBlog?.headline ||
    "Join divine communities of Faith and Spirituality and stay updated on the festivals of India!";

  const img =
    blogData?.mainBlog?.images?.length > 0
      ? blogData?.mainBlog?.images[0]
      : "https://yt3.ggpht.com/ytc/AKedOLQGbAKixMk6KYgpHzIhr8toTKk3RCuyzgPc989W=s900-c-k-c0x00ffffff-no-rj";

  const plainText = getPureText(blogData?.mainBlog?.text);
  const blogContent = plainText?.slice(0, 160) || "";
  let pageUrl;

  if (blogData.mainBlog.BlogCategoryRelations.length === 0) {
    pageUrl =
      blogData.mainBlog.language === LANGUAGE.ENGLISH
        ? `${appBaseUrl}/blogs/${blogData.mainBlog.urlExtension}`
        : `${appBaseUrl}/${blogData.mainBlog.language}/blogs/${blogData.mainBlog.urlExtension}`;
  } else {
    pageUrl =
      blogData.mainBlog.language === LANGUAGE.ENGLISH
        ? `${appBaseUrl}/blog/${blogData.mainBlog.BlogCategoryRelations[0]?.BlogCategory?.blogCategoryUrlExtension}/${blogData.mainBlog.urlExtension}`
        : `${appBaseUrl}/${blogData.mainBlog.language}/blog/${blogData.mainBlog.BlogCategoryRelations[0]?.BlogCategory?.blogCategoryUrlExtension}/${blogData.mainBlog.urlExtension}`;
  }

  const wordCount = blogData.mainBlog.text
    ? blogData.mainBlog.text.split(" ").length
    : 0;

  const metaData = {
    pageUrl: pageUrl,
    headline: headline,
    share_headline: headline.replace(/ /g, "-"),
    author_name: blogData.mainBlog.User.name.replace(/ /g, "_"),
    read_time: readingTime(blogData.mainBlog.text),
    published_time: new Date(parseInt(blogData.mainBlog.ts)),
    blogContent,
    img,
    keywords: blogData.mainBlog.keywords,
    wordCount: wordCount,
  };

  return metaData;
};
